import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import { Image } from 'react-bootstrap';
// import Stack from 'react-bootstrap/Stack';
import Carousel from 'react-bootstrap/Carousel';
import { MDBContainer } from "mdb-react-ui-kit";

var schools = [
    {
      id: 1,
      image: require('../assets/images/elem.jpg'),
      title: 'Don Manuel I. Abella Central School',
      description: '2009 - 2015',
      link: 'https://www.facebook.com/DonManuelIAbella/'
    },
    {
      id: 2,
      image: require('../assets/images/highschool.jpg'),
      title: 'Cararayan National High School',
      description: '2016-2021',
      link: 'https://www.facebook.com/cararayannhs1989/'
    },
    {
      id: 3,
      image: require('../assets/images/ncf.jpg'),
      title: 'Naga College Foundation, Inc.',
      description: '2021 - Present',
      link: 'https://www.ncf.edu.ph/'
    }
  ]


function Education () {

    return (
        <section id="education" className="block education-block">
            <Container fluid>
            <div className='title-holder'>
                    <h2>Education</h2>
                </div>
            <Carousel fade>
                {
                    schools.map(education => {
                        return (
                            <Carousel.Item key={education.id}>
                    <img
                        className="d-block img-fluid" id="education-carousel"
                        src={education.image}
                        alt={"slide " + education.id}
                        />
                    <Carousel.Caption>
                        <h2>{education.title}</h2>
                        <p>{education.description}</p>
                        <a className="btn btn-primary" href={education.link}>Visit<i className="fas fa-chevron-right"></i></a>
                    </Carousel.Caption>             
                    </Carousel.Item>
                );
            })
        }
            </Carousel>

            <Row>
                <Col xs={6}>
                    <MDBContainer className="py-5" id="timeline-container">
                        <h3 className="fw-bold">Academic Background</h3>
                        <p></p>
                        <ul className="timeline">
                            <li className="timeline-item mb-5">
                            <h5 className="fw-bold" id='timeline-title'>Naga College Foundation</h5>
                            <p className="mb-2 fw-bold" id='timeline-content'>2021 - Present</p>
                            <p></p>
                            <p className="timeline-course">Bachelor of Science in Computer Science</p>
                            <p></p>
                            <p id='timeline-content'>• 1st semester 2021-2022 - Dean's Lister</p>
                            <p id='timeline-content'>• 2nd semester 2021-2022 - Dean's Lister</p>
                            <p id='timeline-content'>• 1st semester 2022-2023 - Dean's Lister</p>
                            <p id='timeline-content'>• 2nd semester 2022-2023 - Dean's Lister</p>
                            <p id='timeline-content'>• 1st semester 2023-2024 - Dean's Lister</p>
                            </li>
                            <li className="timeline-item mb-5">
                            <h5 className="fw-bold" id='timeline-title'>Cararayan National High School</h5>
                            <p className="mb-2 fw-bold">2019 - 2021</p>
                            <p className="timeline-course">TVL - Computer Systems Servicing</p>
                            <p id='timeline-content'>• 1st semester 2020-2021 - With Honors</p>
                            <p id='timeline-content'>• 2nd semester 2020-2021 - With Honors</p>
                            </li>
                            <li className="timeline-item mb-5">
                            <h5 className="fw-bold" id='timeline-title'>Cararayan National High School</h5>
                            <p className="mb-2 fw-bold">2015 - 2019</p>
                            <p className="timeline-course">Special Science Class</p>
                            <p id='timeline-content'>• 2015-2016 - With Honors</p>
                            <p id='timeline-content'>• 2016-2017 - With Honors</p>
                            <p id='timeline-content'>• 2017-2018 - With Honors</p>
                            <p id='timeline-content'>• 2018-2019 - Outstanding Performance in Arts</p>
                            <p id='timeline-content'>• 2016-2019 - Cartoonist at The Glimpses</p>
                            </li>
                            <li className="timeline-item mb-5">
                            <h5 className="fw-bold" id='timeline-title'>Don Manuel I. Abella Central School</h5>
                            <p className="mb-2 fw-bold">2009 - 2015</p>
                            <p className="timeline-course">Basic Education Curriculum</p>
                            <p id='timeline-content'>• 2009-2010: 1st grade - 6th top placer</p>
                            <p id='timeline-content'>• 2010-2011: 2nd grade - 11th top placer</p>
                            <p id='timeline-content'>• 2011-2012: 3rd grade - 10th top placer</p>
                            <p id='timeline-content'>• 2012-2013: 4th grade - 15th top placer</p>
                            <p id='timeline-content'>• 2013-2014: 5th grade - 13th top placer</p>
                            <p id='timeline-content'>• 2011-2012: Festival of Academic Talents (Hekasi) - 1st placer</p>
                            <p id='timeline-content'>• 2013-2015: Cartoonist at School Publication</p>

                            </li>
                        </ul>
                    </MDBContainer>
                </Col>
                <Col xs={6}>
                <MDBContainer className="py-5" id="timeline-container">
                        <h3 className="fw-bold">Work Experience / Internship</h3>
                        <p></p>
                        <ul className="timeline">
                            <li className="timeline-item mb-5">
                            <h5 className="fw-bold" id='timeline-title'>The Naga Collegian</h5>
                            <p className="mb-2 fw-bold" id='timeline-content'>2022 - Present</p>
                            <p></p>
                            <p className="timeline-course">Naga College Foundation</p>
                            <p></p>
                            <p id='timeline-content'>• 2022-2023 - Junior Cartoonist</p>
                            <p id='timeline-content'>• 2023-Present - Senior Cartoonist</p>
                            </li>
                            <li className="timeline-item mb-5">
                            <h5 className="fw-bold" id='timeline-title'>Premium Events</h5>
                            <p className="mb-2 fw-bold">2021-Present</p>
                            <p className="timeline-course">Naga City</p>
                            <p id='timeline-content'>• 2021-Present - Event Designer</p>
                            </li>
                            <li className="timeline-item mb-5">
                            <h5 className="fw-bold" id='timeline-title'>S Events and Styles</h5>
                            <p className="mb-2 fw-bold">2020 - Present</p>
                            <p className="timeline-course">Naga City</p>
                            <p id='timeline-content'>• 2020-Present - Event Designer</p>
                            </li>
                            <li className="timeline-item mb-5">
                            <h5 className="fw-bold" id='timeline-title'>Erwin Events and Styles</h5>
                            <p className="mb-2 fw-bold">2020 - Present</p>
                            <p className="timeline-course">Naga City</p>
                            <p id='timeline-content'>• 2020-Present - Event Designer</p>
                            </li>
                        </ul>
                    </MDBContainer>
                </Col>
            </Row>
        </Container>
        </section>
    );

}

export default Education;

